module.exports = __webpack_public_path__ + "img/locking_illustration_step_3.2744e90.png";